/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Pagination_PageInputs */

const es_admin_traces_pagination_page = /** @type {(inputs: Admin_Traces_Pagination_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página`)
};

const en_admin_traces_pagination_page = /** @type {(inputs: Admin_Traces_Pagination_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page`)
};

/**
* | output |
* | --- |
* | "Page" |
*
* @param {Admin_Traces_Pagination_PageInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_pagination_page = /** @type {((inputs?: Admin_Traces_Pagination_PageInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Pagination_PageInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_pagination_page(inputs)
	return en_admin_traces_pagination_page(inputs)
});
export { admin_traces_pagination_page as "admin.traces.pagination.page" }